import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getInsurance = (documentId, siteId) => get(`${url}/leasingoffers/${documentId}/${siteId}/insurances-by-company`);

const getInsuranceCompanies = (documentId, siteId) =>
  get(`${url}/leasingoffers/${documentId}/${siteId}/insuranceCompanies`);

const getInsuranceProducts = (documentId, siteId) =>
  get(`${url}/leasingoffers/${documentId}/${siteId}/insuranceProducts`);

const saveInsurance = (documentId, siteId, insurance) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/insurance`, insurance);
};

const exp = {
  getInsurance,
  getInsuranceCompanies,
  getInsuranceProducts,
  saveInsurance
};
export default exp;
